export enum FinancesOrigin {
	Profile = "profile",
	Dashboard = "dashboard",
}

export enum IncomeBackTo {
	Intro = "intro",
	Overview = "overview",
	Dashboard = "dashboard",
}

export type FinancesNavigationState = {
	from?: FinancesOrigin;
	incomeBackTo?: IncomeBackTo;
};
